module.exports = "<div id=\"container\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/console-pane/console-pane.component.html
// module id = ./src/app/components/console-pane/console-pane.component.html
// module chunks = main